<template>
  <div class="mission_view_800">
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <confirm-dialog ref="confirmSendingOtherCode">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4" style="color: white"
          @click="acceptSendingToOtherCodeConfirmation()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn mx-2"
          @click="cancelSendingOtherCodeConfirmation()">
          خیر
        </v-btn>
        <v-btn elevation="0" small rounded color="grey lighten-3" class="normal-letter-spacing px-10"
          @click="ignoreSendingOtherCodeConfirmation()">
          انصراف
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="bottomListItemsModal" width="500" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-office-building</v-icon>
              <span class="modal-title-text mr-2">ستون های نمایشی</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeOtherOrganModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12" v-for="item in bottomListTableHeader" :key="item.id">
              <v-checkbox v-model="item.show" :label="item.text" hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="1200" v-model="editModal" persistent>
      <edit-eoc-mission-component v-if="editModal" :missionId="missionId" :missionPhoneId="missionPhoneId"
        :missionCode="missionPhoneCode" :phoneCode="phoneCode" :phoneId="phoneId"></edit-eoc-mission-component>
    </v-dialog>

    <v-row no-gutters>
      <v-col cols="12" class="mt-11">
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="mission-800-list-card">
              <v-card-text class="">
                <div class=" btnContolerBottomList">
                  <div class=" itemBtn">
                    <span class="current-mission-header-content">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" size="16" :color="show1024Flag ? '#464646' : '#ff0000'"
                            @click="toggle1024(!show1024Flag)" v-bind="attrs" v-on="on">
                            {{ show1024Flag ? 'mdi-eye' : 'mdi-eye-off' }}
                          </v-icon>
                        </template>
                        <span>
                          {{ show1024Flag ? ' نمایش کدهای 10-24 موقت' : ' عدم نمایش کدهای 10-24 موقت' }}
                        </span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" size="16" :color="silentBottomListSound ? '#ff0000' : '#464646'"
                            @click="handleAlarmBottomListManual()" v-bind="attrs" v-on="on">
                            {{ silentBottomListSound ? 'mdi-bell-off-outline' : 'mdi-bell-outline' }}
                          </v-icon>
                        </template>
                        <span>{{ silentBottomListSound ? 'صدای هشدار خاموش' : 'صدای هشدار روشن' }}</span>
                      </v-tooltip>
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-3" :class="{ 'refresh-btn': bottomListManualRefreshLoaderFlag }"
                            v-bind="attrs" v-on="on" @click="refreshBottomListManual()">
                            mdi-cached mdi-18px
                          </v-icon>
                        </template>
                        <span>به روز رسانی</span>
                      </v-tooltip>
                      ماموریت های جاری (
                      {{ bottomListFilterList.length }} )
                    </span>
                  </div>
                  <div class=" itemBtn item2">
                    <v-text-field hide-details rounded placeholder="کد" outlined v-model="searchTextCode" dense
                      class="current-mission-text-field"></v-text-field>
                  </div>
                  <div class=" itemBtn item4">
                    <v-text-field hide-details rounded placeholder="جستجو..." outlined
                      v-model="currentMissionSearchText" dense class="current-mission-text-field"></v-text-field>
                  </div>
                  <div class=" itemBtn item3">
                    <v-autocomplete hide-details :items="allZones" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                      rounded item-text="title" item-value="value" clearable clear-icon="mdi-close mdi-18px"
                      append-icon="" multiple placeholder="ناحیه" autocomplete="off" class="current-mission-select"
                      v-model="selectedZone" :menu-props="{ contentClass: 'zone-autocomplete-menu' }"></v-autocomplete>
                  </div>
                </div>
                <!-- bottom table -->
                <template>
                  <!-- @contextmenu:row="onContextClick" کلیک راست جدول-->
                  <v-data-table id="bottomTable2" fixed-header :headers="bottomListTableHeader"
                    :items="bottomListFilterList" :items-per-page="bottomListFilterList.length"
                    :height="bottomTableHight" dense loading-text="به روزرسانی.... لطفا منتظر بمانید"
                    :hide-default-footer="true" multi-sort
                    :item-class="(item) => `${selectedRow === item?.id ? 'heighlighted-row' : ''}`"
                    class="elevation-0 bottomTable" @dblclick:row="showEditModal" @click:row="invokeToCodeInMap"
                    :search="currentMissionSearchText">
                    <!--                    v-sortable-table="{
                      onEnd: sortTheHeadersAndUpdateTheKey,
                      active: false,
                    }"
                    :key="anIncreasingNumber"-->
                    <template v-slot:[`item.icon`]="{ item }">
                      <v-row>
                        <v-col cols="12">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="4" v-for="(data, index9) in item.iconData" :key="'jkj' + index9">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon @click="handleClickIconStatus(item.toopakId, data)" :color="data.color"
                                    v-bind="attrs" v-on="on">
                                    {{ data.icon }}
                                  </v-icon>
                                </template>
                                <span>{{ data.text }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                      <v-row dir="rtl" v-if="item.hasAddressChanged == true" class="bottom-list-address" no-gutters>
                        <v-col cols="12" class="text-right pr-2">
                          <div class="my-row">
                            <v-col class="bottom-list-change-address-space2" v-if="item.hasUnsentAddressNotification">
                              <v-icon class="ml-n5 mt-n1" color="#FF9C78">mdi-circle-medium</v-icon>
                            </v-col>
                            <v-col class="bottom-list-change-address-space" v-if="item.hasUnsentAddressNotification">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col class="bottom-list-change-address-space3" v-else>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1 pr-2">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasAddressChanged == false" no-gutters dir="rtl">
                        <v-col cols="12" class="text-right pr-2">
                          <div class="my-row items-center">
                            <v-col class="bottom-list-change-address-space2" v-if="item.hasUnsentAddressNotification">
                              <v-icon class="ml-6" color="#FF9C78">mdi-circle-medium</v-icon>
                            </v-col>
                            <v-col class="bottom-list-change-address-space" v-if="item.hasUnsentAddressNotification">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                            <v-col class="bottom-list-change-address-space3" v-else>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" class="mr-n2 line-clamp-1">
                                    {{ item.address }}
                                  </div>
                                </template>
                                <span>{{ item.address }}</span>
                              </v-tooltip>
                            </v-col>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.cc`]="{ item }">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-right">
                          <div dir="rtl" class="flex items-center justify-start gap-1">
                            <v-icon :color="item.rankIconColor">
                              mdi-numeric-{{ item?.patientsCount }}-circle
                            </v-icon>
                            <v-icon v-if="item.hasUnsentCcNotification" color="#FF9C78">
                              mdi-circle-medium
                            </v-icon>
                            <div class="line-clamp-1">
                              {{ item.cc }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.hospital`]="{ item }">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-right">
                          <div class="flex items-center gap-1">
                            <v-icon v-if="item.hasUnsentHospitalNotification" color="#FF9C78">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.hospital ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.user`]="{ item }">
                      <app-wrap-text :text="item?.user ?? ''" />
                    </template>
                    <template v-slot:[`item.zone`]="{ item }">
                      <app-wrap-text :text="item?.zone ?? ''" />
                    </template>
                    <template v-slot:[`item.ambulanceCode`]="{ item }">
                      <v-row v-if="item.hasLackOfCode == true && item.status != '10-24 موقت'"
                        class="bottom-list-lake-off-code" no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="flex items-center">
                                <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                                  {{ item.recivedToPhoneState }}
                                </v-icon>
                                <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                              </div>
                            </template>
                            <span>فاقدی</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasLackOfCode == true && item.status == '10-24 موقت'" class="bottom-list-1024"
                        no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="flex items-center">
                                <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                                  {{ item.recivedToPhoneState }}
                                </v-icon>
                                <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                              </div>
                            </template>
                            <span>24-10 موقت</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasLackOfCode == false && item.status == '10-24 موقت'" class="bottom-list-1024"
                        no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on" class="flex items-center">
                                <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                                  {{ item.recivedToPhoneState }}
                                </v-icon>
                                <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                              </div>
                            </template>
                            <span>24-10 موقت</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.hasLackOfCode == false && item.status != '10-24 موقت'" no-gutters>
                        <v-col cols="12" class="text-center">
                          <div v-bind="attrs" v-on="on" class="flex items-center">
                            <v-icon :color="item.recivedToPhoneStateColor" class="ml-2">
                              {{ item.recivedToPhoneState }}
                            </v-icon>
                            <app-wrap-text :text="item?.ambulanceCode ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.shabrangCode`]="{ item }">
                      <v-row v-if="item.status == '10-24 موقت'" class="bottom-list-1024" no-gutters>
                        <v-col cols="12" class="text-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <app-wrap-text v-bind="attrs" :text="item?.shabrangCode ?? ''" v-on="on"></app-wrap-text>
                            </template>
                            <span>24-10 موقت</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row v-if="item.status != '10-24 موقت'" no-gutters>
                        <v-col cols="12" class="text-center">
                          <app-wrap-text :text="item?.shabrangCode ?? ''" />
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.phoneNumber`]="{ item }">
                      <app-wrap-text :text="item?.phoneNumber ?? ''" />
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <v-row v-if="item.status == '10-33'" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status == '10-99'" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.includes('10-19')" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.includes('724')" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.includes('247')" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status == '10-12'" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="item.status.startsWith('بیمارستان')" class="bottom-list-status-10-99"
                        no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <div class="flex items-cetner gap-1">
                            <v-icon v-if="item.hasUnsentStateNotification" color="white">
                              mdi-circle-medium
                            </v-icon>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else no-gutters>
                        <v-col cols="12" class="text-right">
                          <div class="flex items-baseline gap-1">
                            <div>
                              <v-icon v-if="item.hasUnsentStateNotification" color="#FF9C78">
                                mdi-circle-medium
                              </v-icon>
                            </div>
                            <app-wrap-text :text="item?.status ?? ''" />
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.phoneStatus`]="{ item }">
                      <v-row v-if="item.markPhoneCurrentState" class="bottom-list-status-10-99" no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <app-wrap-text :text="item?.phoneStatus ?? ''" />
                        </v-col>
                      </v-row>
                      <v-row v-else no-gutters>
                        <v-col cols="12" class="text-right">
                          <app-wrap-text :text="item?.phoneStatus ?? ''" />
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.ccNote`]="{ item }">
                      <td><app-wrap-text :text="item?.ccNote ?? ''" /></td>
                    </template>
                    <template v-slot:[`item.chiefComplaintText`]="{ item }">
                      <td><app-wrap-text :text="item?.chiefComplaintText ?? ''" /></td>
                    </template>
                    <template v-slot:[`item.phonePreviousState`]="{ item }">
                      <td>
                        <app-wrap-text :text="item?.phonePreviousState ?? ''" />
                      </td>
                    </template>
                    <template v-slot:[`item.ambulanceStatus`]="{ item }">
                      <td><app-wrap-text :text="item?.ambulanceStatus ?? ''" /></td>
                    </template>
                    <template v-slot:no-data>
                      <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                    </template>
                  </v-data-table>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
function watchClass(targetNode, classToWatch) {
  let lastClassState = targetNode.classList.contains(classToWatch);
  const observer = new MutationObserver((mutationsList) => {
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const currentClassState = mutation.target.classList.contains(classToWatch);
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;
          if (!currentClassState) {
            mutation.target.classList.add('sortHandle');
          }
        }
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}
import Sortable from 'sortablejs';
import throttle from 'lodash/throttle'; // rate-limits socket-driven refreshes; trailing:true guarantees the LAST signal is never dropped
import { latLng } from 'leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import AlertComponent from '../../components/AlertComponent.vue';
import EditEocMissionComponent from '../../components/Eoc/EditEocMissionComponent.vue';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AppWrapText from '@/components/app/wrapText.vue';
// ------------option-api--------------------
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import Mission800Helper from '@/Helpers/800/800MissionHelper.js';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MissionLackOFCodeMixin from '@/Mixins/Mission/MissionLackOfCodeMixin.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import CancelReasonMixin from '@/Mixins/BaseInformation/CancelReasonMixin';
import StationCoverageZoneMixin from '@/Mixins/BaseInformation/StationCoverageZoneMixin';
import MapMixin from '@/Mixins/115/MapMixin.js';
import SharedMap from '@/Mixins/map';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import missionOtherOrganizationRequestMixin from '@/Mixins/Mission/MissionOtherOrganizationRequestMixin.js';
import missionOtherOrganizationInformMixin from '@/Mixins/Mission/MissionOtherOrganizationInformMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import TerminehMixin from '@/Mixins/800/termineh.mixin';
import SerachMapMixin from '@/components/app/map/SerachMapMixin.js';
import '@/assets/styles/800.scss';
import Vue from 'vue';

export default {
  name: 'currentMission800View',
  directives: {
    'sortable-table': {
      inserted: (el, binding) => {
        el.querySelectorAll('th').forEach((draggableEl) => {
          // Need a class watcher because sorting v-data-table rows asc/desc removes the sortHandle class
          watchClass(draggableEl, 'sortHandle');
          draggableEl.classList.add('sortHandle');
        });
        Sortable.create(
          el.querySelector('tr'),
          binding.value ? { ...binding.value, handle: '.sortHandle' } : {},
        );
      },
    },
  },
  title: 'ماموریت های جاری Eoc',
  inject: ['load'],
  components: {
    AlertComponent,
    EditEocMissionComponent,
    AppWrapText,
    confirmDialog,
  },
  mixins: [
    ShearedMixin,
    snackBar,
    ShearedHelper,
    Mission800Helper,
    MissionMixin,
    PhoneMixin,
    StationMixin,
    MissionLackOFCodeMixin,
    MissionPhonesMixin,
    CancelReasonMixin,
    StationCoverageZoneMixin,
    MapMixin,
    ZoneMixin,
    DispatchCodeMixin,
    PhoneOnlineLocationMixin,
    CallMixin,
    missionOtherOrganizationRequestMixin,
    missionOtherOrganizationInformMixin,
    OtherOrganizationMixin,
    UserNotificationMixin,
    SharedMap,
    TerminehMixin,
    SerachMapMixin,
  ],
  created() {
    this.$root.$refs.currentMission800View = this;

    // ONE throttled handler shared by BOTH buses:
    //  - collapses duplicate main/mobile broadcasts of the same event into one refresh
    //  - leading:true  → first signal after quiet period refreshes IMMEDIATELY
    //  - trailing:true → the LAST signal inside a burst ALWAYS fires one final refresh
    //    at the end of the window, so the latest state is never missed
    this.throttledMainList800 = throttle(this.fMainList800, 1500, {
      leading: true,
      trailing: true,
    });

    // Sound is throttled separately (longer window) so a burst of signals
    // doesn't stack audio playback and jank the main thread
    this.throttledBottomListSound = throttle(() => {
      if (!this.silentBottomListSound) {
        this.playSound800BottomList();
      }
    }, 5000, { leading: true, trailing: false });

    try {
      this.$mainSignalr.bus.$on('MainList800', this.throttledMainList800);
      this.$mobileSignalr.bus.$on('MainList800', this.throttledMainList800);
      this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
      this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    } catch (error) {
      console.log("error mainSignalr:", error);
    }

  },
  mounted() {
    this.mounteLoding();
    // this.onScroll();
    // this.bottomListFilterList();
    this.getSystemSettingByClientComputer();
    this.setMapBaseSystemSetting();
    this.loadVoicesFromStorage();
    window.addEventListener('keydown', this.handleFunctionKeys);
  },
  data() {
    return {
      searchTextCode: '',
      searchTextCode_Attach: '',
      silentBottomListSound_A: false,
      clickItem: null,
      tempvalue: null,
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stopIconForPhoneWithMission: require('@/assets/images/stopphoneWithMission.svg'),
      stopIconForPhoneWithOutMission: require('@/assets/images/stopphoneWithOutMission.svg'),
      stopIconForGPSWithMission: require('@/assets/images/stopgpsWithMission.svg'),
      stopIconForGPSWithOutMission: require('@/assets/images/stopgpsWithOutMission.svg'),
      dragging: false,
      icon: this.getIcon,
      patientIcon: L.divIcon({
        // @/assets/images/mapMarkerRadius.svg
        html: `<div class="map-icon-ripple"></div>
        <img src="${require('@/assets/images/mapMarkerRadius.svg')}" alt="patient-marker"/>`,
        className: 'map-icon-container',
        iconSize: [30, 30],
        iconAnchor: [0, 0],
      }),
      bottomTableHight: '80vh',
      topTableHight: '25vh',
      bottomListRefreshInFlight: false, // true while an axios refresh is running
      bottomListRefreshPending: false,  // a signal arrived DURING a refresh → run one more after it finishes
    };
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleFunctionKeys);
    this.clearSoundInterval();
    this.cleanupResources();

    // must $off with the SAME function reference that was passed to $on
    this.$mainSignalr.bus.$off('MainList800', this.throttledMainList800);
    this.$mobileSignalr.bus.$off('MainList800', this.throttledMainList800);
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    // drop any queued trailing invocation so a dead component never fetches
    this.throttledMainList800.cancel();
    this.throttledBottomListSound.cancel();

    // stop watching the table's rows (set up in onScroll)
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
      this.stickyObserver = null;
    }

    delete this.$root.$refs.currentMission800View;
  },
  methods: {
    openAttachmentModal() {
      this.searchTextCode_Attach = '';
      this.showCurrentMissionAttachmentModal();
    },
    startsWithFilter(item, queryText, itemText) {
      return itemText.toLowerCase().startsWith(queryText.toLowerCase())
    },
    handelSelectMenu(item) {
      if (item.title == 'اعزام کد مجدد') {
        this.rightClickAction(item.title, null)
      } else if (item.title == 'درخواست موقعیت') {
        this.rightClickAction(item.title, null)
      } else if (item.title == '10-24 موقت') {
        this.showConfirmDialogFor10_24()
      }

    },
    handleAlarmBottomListManual() {
      this.silentBottomListSound = !this.silentBottomListSound;
    },
    shouldShowSpecialStatus(status) {
      const hasAnyItem = this.specialStatuses.some(item => status?.includes(item));

      return hasAnyItem ||
        status?.includes("استقرار") ||
        status?.startsWith("بیمارستان") ||
        status === "درخواست کد سما";
    },
    // handle F Keys
    handleFunctionKeys(e) {
      const keyActions = {
        F9: () => this.handleSubmitForms(),
      };

      if (keyActions[e.key] && this.sendTOPhoneModal) {
        e.preventDefault();
        keyActions[e.key]();
      }
    },
    handleSubmitForms() {
      if (this.sendModalType === 'main') {
        this.sendMissionToPhoneCheckType();
      } else {
        this.sendToOtherCodeConfirmation();
      }
    },
    handleEnterLack() {
      this.$nextTick(() => {
        if (this.selectedMissionLakeCode) {
          this.addMissionLakeCode();
        }
      });
    },
    sortTheHeadersAndUpdateTheKey(evt) {
      const headersTmp = this.bottomListTableHeader;
      const oldIndex = evt.oldIndex;
      const newIndex = evt.newIndex;
      if (newIndex >= headersTmp.length) {
        let k = newIndex - headersTmp.length + 1;
        while (k--) {
          headersTmp.push(undefined);
        }
      }
      headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
      this.table = headersTmp;
      this.anIncreasingNumber += 1;
      setTimeout(() => {
        var mtable = document.getElementsByTagName('table');
        this.resizableGrid(mtable[0]);
      }, 700);
    },
    mounte: function () {
      try {
        var tables = document.getElementsByTagName('table');
        this.resizableGrid(tables[0]);

        L.Icon.Default.mergeOptions({
          iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
          iconUrl: require('@/assets/images/marker-icon.png'),
          shadowUrl: require('@/assets/images/marker-shadow.png'),
        });
        this.refreshBottomList(); // initial load goes through the same guarded pipeline
        this.getListOfOtherOrganizationsForOther();
        this.getAllZones();
        this.onScroll();
        if (screen.height <= 728) {
          this.bottomTableHight = '80vh';
        } else if (screen.height >= 850) {
          this.bottomTableHight = '85vh';
        } else if (screen.height >= 800) {
          this.bottomTableHight = '84vh';
        } else if (screen.height >= 750) {
          this.bottomTableHight = '83vh';
        } else {
          this.bottomTableHight = '80vh';
        }
      } catch (error) {
        console.log("AA error: ", error);
      }
    },
    getData: function () {
      console.log("");
    },
    fMainList800: function () {
      this.throttledBottomListSound(); // sound has its own (longer) throttle window
      this.refreshBottomList();
    },
    // Latest-wins refresh pipeline. Guarantees:
    //  1. never more than ONE request in flight (no request stacking)
    //  2. a signal that arrives WHILE a request is running sets `pending`,
    //     and exactly one more refresh runs right after → final state always
    //     reflects the LAST signal received, nothing is ever silently dropped
    refreshBottomList: async function () {
      if (this.bottomListRefreshInFlight) {
        this.bottomListRefreshPending = true; // remember: new data exists, fetch again after this one
        return;
      }
      this.bottomListRefreshInFlight = true;
      try {
        // NOTE: for the in-flight guard to work, the mixin method must RETURN
        // its axios promise:  return this.axios.get(...)  /  return await ...
        await this.getListOfDispatchBottomListFunction();
      } catch (error) {
        console.log('refreshBottomList error:', error);
      } finally {
        this.bottomListRefreshInFlight = false;
        if (this.bottomListRefreshPending) {
          this.bottomListRefreshPending = false;
          this.refreshBottomList(); // one trailing refresh → latest server state
        }
      }
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
    onGetAllUserNotificationOnSignal: function () {
      this.getAllUserNotificationsOnSignal();
    },

    invokeToCodeInMap: function (value, data) {
      this.selectedRow = data.item?.id;
      this.clickItem = value;
      const connection = Vue.prototype.$mainSignalr?.connection;
      if (!connection || connection.state !== 'Connected') {
        console.warn('[SignalR2] connection not ready');
        return;
      }
      connection.invoke('Location', data.item.ambulanceCode.toString()).catch((err) => {
        console.error('[SignalR2] invoke Location failed:', err);
      });
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },

    // Rewritten onScroll:
    //  - the legacy version added mouseover/mouseout listeners to EVERY row on EVERY
    //    scroll event → listeners accumulated endlessly and the tab degraded over time
    //  - this version attaches listeners ONCE, uses event DELEGATION (closest('tr')),
    //    so it survives row re-renders after each refresh and never leaks
    //  - scroll work is batched with requestAnimationFrame (max once per frame)
    //  - NEW: a MutationObserver re-applies the sticky styles whenever Vue
    //    re-renders the rows (refresh / filter / search / sort). Previously the
    //    styles were only applied inside the scroll listener, so freshly
    //    rendered <td>s had NO sticky positioning and the row text visually
    //    bled under the two frozen columns until the user moved the scrollbar.
    onScroll() {
      const table = document.querySelectorAll('.v-data-table')[0]?.children[0];
      if (!table) return;

      // paints the two RTL-sticky cells (index 13 & 14) of one row
      const paintRow = (row, color) => {
        if (!row || !row.children || !row.children[14]) return;
        row.children[14].style.backgroundColor = color;
        row.children[13].style.backgroundColor = color;
      };

      // ONE delegated listener per event type on the wrapper — never per row
      table.addEventListener('click', (e) => paintRow(e.target.closest('tr'), '#cbcbcb'));
      table.addEventListener('contextmenu', (e) => paintRow(e.target.closest('tr'), '#cbcbcb'));
      table.addEventListener('mouseover', (e) => paintRow(e.target.closest('tr'), '#cbcbcb'));
      table.addEventListener('mouseout', (e) => {
        const row = e.target.closest('tr');
        if (!row) return;
        // selected row keeps its highlight, others go back to white
        const isSelected = [...row.classList].some((c) => c === 'heighlighted-row');
        paintRow(row, isSelected ? '#cbcbcb' : 'white');
      });

      // rAF-batched runner shared by the scroll listener AND the row observer:
      // no matter how many scroll events / DOM mutations land in one frame,
      // applySticky runs at most once per frame
      let stickyTicking = false;
      const scheduleSticky = () => {
        if (stickyTicking) return;
        stickyTicking = true;
        requestAnimationFrame(() => {
          stickyTicking = false;
          applySticky(table);
        });
      };

      table.addEventListener('scroll', scheduleSticky);

      // Re-apply sticky styles whenever the row set changes (refresh, filter,
      // :search, sort, pagination). Vue replaces the <tr>/<td> nodes on every
      // re-render, wiping the inline styles applySticky set — and since no
      // scroll event fires on a data change, nothing repainted them before.
      // Loop-safe: applySticky only touches style ATTRIBUTES, and the observer
      // only watches childList (node add/remove), so it never triggers itself.
      this.stickyObserver?.disconnect(); // idempotent if onScroll ever re-runs
      this.stickyObserver = new MutationObserver(scheduleSticky);
      this.stickyObserver.observe(table, { childList: true, subtree: true });

      // paint the initial render too (previously nothing ran until first scroll)
      scheduleSticky();

      function applySticky(target) {
        const ths = target.querySelectorAll('th');
        const secondCol = ths[13];
        const firstCol = ths[14];
        if (!secondCol || !firstCol) return;
        const maxScrollLeftValue = target.scrollWidth - target.clientWidth;
        const stickyOn = maxScrollLeftValue > target.scrollLeft;

        if (stickyOn) {
          secondCol.style.position = 'sticky';
          secondCol.style.right = `${firstCol.offsetWidth}px`;
          secondCol.style.backgroundColor = 'white';
          secondCol.style.borderLeft = '1px solid #212121';
        } else {
          secondCol.style.position = 'relative';
          secondCol.style.left = '0px';
          secondCol.style.borderLeft = 'none';
        }

        const rows = target.querySelectorAll('tr');
        rows.forEach((row) => {
          const secondTd = row.querySelectorAll('td')[13];
          const firstTd = row.querySelectorAll('td')[14];
          if (!secondTd || !secondTd.style) return;
          const isSelected = [...row.classList].some((c) => c === 'heighlighted-row');

          if (stickyOn) {
            secondTd.style.position = 'sticky';
            secondTd.style.right = `${firstCol.offsetWidth}px`;
            secondTd.style.borderLeft = '1px solid #212121';
            secondTd.style.backgroundColor = isSelected ? '#cbcbcb' : 'white';
            if (firstTd && firstTd.style) {
              firstTd.style.backgroundColor = isSelected ? '#cbcbcb' : 'white';
            }
          } else {
            secondTd.style.position = 'relative';
            secondTd.style.right = '0px';
            secondTd.style.borderLeft = 'none';
            secondTd.style.backgroundColor = 'transparent';
          }
        });
      }
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    getMovingIcon(data) {
      if (data.speed >= 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        }
      } else if (data.speed < 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        }
      }
    },
    // Rewritten column resize:
    //  - resizing a column NO LONGER touches its neighbor; the table width absorbs
    //    the delta instead, so every other column keeps its exact width
    //  - all columns are pinned to explicit px widths at init, otherwise
    //    table-layout:fixed silently redistributes the unpinned ones
    //  - document mousemove/mouseup listeners now live only for the duration of
    //    one drag (added on mousedown, removed on mouseup) — the old version
    //    registered a pair PER COLUMN, PER CALL, and never removed them
    resizableGrid: function (table) {
      const element = document.getElementsByClassName('v-data-table__wrapper')[0];
      element.scrollLeft += element.scrollWidth;
      var row = table.getElementsByTagName('tr')[0],
        cols = row ? row.children : undefined;
      if (!cols) return;
      table.style.overflow = 'scroll';
      table.style.tableLayout = 'fixed';

      var tableHeight = table.offsetHeight;

      // drag state shared between the handlers of the ACTIVE drag only
      var drag = { curCol: null, pageX: 0, curColWidth: 0, tableStartWidth: 0 };

      // pin every column once → the browser can no longer redistribute widths
      for (var p = 0; p < cols.length; p++) {
        cols[p].style.width = (cols[p].offsetWidth - paddingDiff(cols[p])) + 'px';
      }

      for (var i = 0; i < cols.length; i++) {
        var div = createDiv(tableHeight);
        cols[i].appendChild(div);
        cols[i].style.position = 'relative';
        setListeners(div);
      }

      function onMouseMove(e) {
        if (!drag.curCol) return;
        var diffX = e.pageX - drag.pageX;
        // handle is on the LEFT edge (RTL): dragging LEFT (negative diffX) = wider
        var newWidth = Math.max(40, drag.curColWidth - diffX); // clamp: no negative/vanishing columns
        drag.delta = newWidth - drag.curColWidth; // remembered for mouseup normalization

        // ONLY the dragged column changes; the table grows/shrinks by the same
        // delta, so neighbors are never squeezed
        drag.curCol.style.width = newWidth + 'px';
        table.style.width = (drag.tableStartWidth + drag.delta) + 'px';

        if (drag.wrapperIsRtl) {
          // native RTL wrapper: browser anchors content to the right; keep the
          // grabbed edge pinned by offsetting the scroll
          drag.wrapper.scrollLeft = drag.wrapperStartScroll - drag.delta;
        } else {
          // LTR wrapper: the browser anchors the table's LEFT edge, so growth
          // alone extends rightward. Shifting the table by -delta pins the RIGHT
          // edge instead → columns to the LEFT of the drag slide left, columns to
          // the right stay put, the view and scrollbar don't move at all.
          table.style.marginLeft = (-drag.delta) + 'px';
        }
      }

      function onMouseUp() {
        // convert the temporary margin shift into a real scroll offset, so the
        // far-left columns remain reachable after the drag ends
        if (drag.curCol && !drag.wrapperIsRtl && drag.delta) {
          table.style.marginLeft = '';
          drag.wrapper.scrollLeft = Math.max(0, drag.wrapperStartScroll + drag.delta);
        }
        drag.curCol = null;
        drag.delta = 0;
        // listeners exist only while dragging → nothing accumulates
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      function setListeners(div) {
        div.addEventListener('mousedown', function (e) {
          e.preventDefault(); // stop text selection while dragging
          drag.curCol = e.target.parentElement;
          drag.pageX = e.pageX;
          drag.delta = 0;
          drag.curColWidth = drag.curCol.offsetWidth - paddingDiff(drag.curCol);
          drag.tableStartWidth = table.offsetWidth;

          // snapshot the scroll container once per drag
          drag.wrapper = table.closest('.v-data-table__wrapper') || element;
          drag.wrapperIsRtl = getStyleVal(drag.wrapper, 'direction') === 'rtl';
          drag.wrapperStartScroll = drag.wrapper.scrollLeft;

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });

        div.addEventListener('mouseover', function (e) {
          e.target.style.borderLeft = '2px solid #0000ff'; // indicator on the grab edge
        });

        div.addEventListener('mouseout', function (e) {
          e.target.style.borderLeft = '';
        });
      }

      function createDiv(height) {
        var div = document.createElement('div');
        div.style.top = 0;
        div.style.left = 0; // RTL: resize from the column's LEFT edge
        div.style.width = '5px';
        div.style.position = 'absolute';
        div.style.cursor = 'col-resize';
        div.style.userSelect = 'none';
        div.style.height = height + 'px';
        return div;
      }

      function paddingDiff(col) {
        if (getStyleVal(col, 'box-sizing') == 'border-box') {
          return 0;
        }

        var padLeft = getStyleVal(col, 'padding-left');
        var padRight = getStyleVal(col, 'padding-right');
        return parseInt(padLeft) + parseInt(padRight);
      }
      function getStyleVal(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css);
      }
    },
  },
  computed: {
    visibleRightClickItems() {
      return this.rightClickItems.filter(item => {
        if (item.title === 'تماس با بیمارستان') {
          return this.hospitalPhoneNumbers?.length > 0;
        }
        return true;
      });
    },
    silentBottomListSound: {
      get() {
        return this.silentBottomListSound_A;
      },
      set(value) {
        this.silentBottomListSound_A = value;
      }
    },
    specialStatuses() {
      const fixed = ["10-33", "10-99", "10-19", "10-12", "10-51", "10-10", "10-63", "10-60", "10-7", "10-24", "10-51"];
      const apiTitles = this.allOtherOrganizationsForOther?.map(item => item.title);
      return [...fixed, ...apiTitles];
    },
    //Voice
    formattedTime() {
      const mins = Math.floor(this.recordingSeconds / 60);
      const secs = this.recordingSeconds % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },
    bottomListFilterList() {
      const zones = [...this.selectedZone];
      const list = [...this.filteredBottomList];

      let result = [];

      if (zones.length === 0) {
        result = list;
      } else {
        const zoneSet = new Set(zones);
        result = list.filter((u) => {
          return zoneSet.has(u.zone) || zones.some(zone => u.zone?.includes(zone));
        });
      }
      if (this.searchTextCode && this.searchTextCode.trim() !== '') {
        const searchLower = this.searchTextCode.toLowerCase().trim();
        result = result.filter((u) => {
          return (
            u.ambulanceCode?.toLowerCase().includes(searchLower) ||
            u.shabrangCode?.toLowerCase().includes(searchLower)
          );
        });
      }

      return result;
    },
    attachallFilterList() {
      const list = [...this.allAttachment];
      let result = list;

      if (this.searchTextCode_Attach && this.searchTextCode_Attach.trim() !== '') {
        const searchLower = this.searchTextCode_Attach.toLowerCase().trim();
        result = result.filter((u) => {
          return (u.code?.toLowerCase().includes(searchLower));
        });
      }

      return result;
    }
  },
  watch: {
    patiantPosition: function (value) {
      this.$refs.modalmap.mapObject?.flyTo(value, 16);
    },
    currentMissionSearchText() {
      this.$nextTick(() => {
        const wrapper = document.querySelector('#bottomTable2 .v-data-table__wrapper');
        if (wrapper) wrapper.scrollTop = 0;
      });
    }
  },
};
</script>
<style lang="scss">
.btnContolerBottomList {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-top: -32px;
  margin-bottom: 8px;

  .itemBtn {
    display: flex;
    justify-content: center;
    align-items: center;

    &.item2 {
      max-width: 150px;
    }

    &.item3 {
      min-width: 400px;
      margin-right: 10px;
    }

    &.item4 {
      margin-right: auto;
    }

    .blue-text-btn {
      background-color: #dde4ff !important;
      color: var(--dark-color) !important;
      border: 1px solid var(--dark-color) !important;
    }

    .blue-text-btn .v-icon {
      color: var(--dark-color) !important;
    }

    .blue-text-btn:hover {
      background-color: #f5f5f5 !important;
    }
  }

}

.btnImmigration {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: auto;

  >button {
    background: var(--v-darkColor-base);
    border-radius: 8px;
    color: white;
    font-size: 14px;
    font-weight: 400;
    padding: 4px 12px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    margin-right: auto;

    &:hover {
      opacity: 0.9;
      box-shadow: 2px 2px 7px 2px #0000004e;
    }
  }
}

.voiceDialog {
  .t1 {
    font-size: 17px !important;
    font-weight: 500;
  }

  .t2 {
    font-size: 15px !important;
    font-weight: 500;
  }
}

.refresh-btn {
  animation-name: spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.mission_view_800 {

  span,
  div,
  td {
    div {
      -webkit-user-select: none !important;
      /* Safari */
      -ms-user-select: none !important;
      /* IE 10 and IE 11 */
      user-select: none !important;
      /* Standard syntax */
    }
  }
}

#topTable {
  thead {
    tr {
      z-index: 1 !important;
    }
  }
}

.cancel-style {
  background: #ff9c78 !important;

  td {
    background: #ff9c78 !important;
  }

  color: white;
}

#bottomTable2 {
  thead {
    tr {
      z-index: 1 !important;
    }

    th:last-of-type {
      position: sticky !important;
      background-color: white;
      right: 0;
    }
  }

  tbody {
    td:last-of-type {
      position: sticky;
      right: 0;
      // default paint so a freshly rendered row is never transparent while
      // pinned (JS inline styles from applySticky/paintRow still override this
      // for hover/selection, since inline beats the stylesheet)
      background-color: white;
    }
  }
}

.freezCol {
  position: sticky;
  background-color: white;
  right: 90px;
}

.heighlighted-row {
  background-color: #cbcbcb !important;
  color: white !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
<style scoped>
>>>.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 6px !important;
}

/* //Voice */
.recording-indicator {
  padding: 16px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.recording-indicator.is-recording {
  animation: pulse 1.5s infinite;
  background-color: rgba(255, 0, 0, 0.1);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
  }

  70% {
    box-shadow: 0 0 0 15px rgba(255, 0, 0, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

/* //Voice  */
.mission-800-list-card {
  border: 1px solid var(--dark-color) !important;
  background: white !important;
}

.current-mission-header-content {
  font-size: 13px;
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.covered-position {
  margin-top: -3.5vh !important;
}

.covered-position3 {
  margin-top: -2.5vh !important;
}

.covered-position2 {
  margin-top: -4.2vh !important;
}

.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.x-overflow {
  overflow-x: auto !important;
}

.send-mission-detail-card {
  border: 1px solid var(--dark-color) !important;
}

.send-mission-detail-card-body {
  height: 10vh !important;
  overflow-y: auto !important;
}

.send-mission-title-content {
  color: var(--dark-color) !important;
  font-weight: 500;
  font-size: 11px;
  background: white !important;
  margin-top: -1.5vh !important;
  margin-right: 2vh !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.send-mission-title-content2 {
  color: var(--dark-color) !important;
  font-weight: 500;
  font-size: 13px;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 500;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}

.missionSendInfo-diagnosis-title {
  max-width: 120px;
}

.mission-card-header-rank-title {
  font-weight: 500;
  font-size: 14px;
  color: #212121 !important;
}

.mission-card-header-rank-text {
  font-weight: 400;
  font-size: 13px;
  color: #212121 !important;
}

.bottom-bar {
  position: absolute !important;
  top: 100% !important;
}

.map-popup {
  width: 70px !important;
  overflow-x: hidden !important;
}

.popup-items-content {
  font-size: 12px !important;
}

>>>.current-mission-text-field fieldset {
  background: white !important;
}

>>>.current-mission-select fieldset {
  background: white !important;
}

.right-click-menu-title {
  font-size: 12px !important;
}

.bottom-list-address {
  background: #9fe2ff !important;
  border-radius: 5px !important;
  /*height: 70% !important;
  max-height: 70% !important;
  min-height: 70% !important;*/
}

.bottom-list-lake-off-code {
  /* background: #f0f0f0 !important; */
  background: #f8eaff !important;
  border-radius: 5px !important;
}

.bottom-list-1024 {
  background: #cacaca !important;
  border-radius: 5px !important;
}

.bottom-list-status-10-99 {
  background: #ff9c78 !important;
  border-radius: 5px !important;
  color: white;
}

.bottom-list-status-10-33 {
  background: #ffd89b !important;
  border-radius: 5px !important;
}

.rank-icon-anim1 {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

.rank-icon-anim2 {
  animation: shake2 0.5s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@keyframes shake2 {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(5deg);
  }

  50% {
    transform: rotate(0deg);
  }

  75% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

>>>.bottomTable.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.bottomTable .v-data-table__wrapper table {
  margin-left: auto !important;
}

>>>.bottomTable .v-data-table__wrapper table tbody tr td {
  font-size: 14px !important;
  font-weight: 600 !important;
}

>>>.bottomTable .v-data-table-header tr th {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: black !important;
}

>>>.top-table.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.top-table .v-data-table__wrapper table tbody tr td {
  font-size: 14px !important;
  font-weight: 600 !important;
}

>>>.top-table .v-data-table-header tr th {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: black !important;
}

>>>.current-mission-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.current-mission-text-field.v-input input {
  max-height: 30px !important;
}

>>>.current-mission-select .v-input__control .v-input__slot {
  min-height: 15px !important;
  max-height: 30px !important;
  font-size: 10px !important;
}

>>>.current-mission-select.v-input input {
  min-height: 15px !important;
  max-height: 30px !important;
  font-size: 10px !important;
}


.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.other-organ-selected-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.other-organ-sugest-card-part {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
}

.other-organ-sugest-user {
  position: absolute;
  margin-top: -12px;
  margin-right: 24px;
  padding-left: 8px;
  padding-right: 5px;
  background: white;
  font-size: 12px;
}

.other-organ-selected-span {
  background: var(--background-color) !important;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 30px !important;
  font-size: 12px;
}

>>>.bottomTable th {
  border-right: 1px solid grey !important;
}

>>>.bottomTable td {
  border-right: 1px solid grey !important;
}

>>>.table-top-800 td {
  border-right: 1px solid grey !important;
}

>>>.table-top-800 th {
  border-right: 1px solid grey !important;
}

/*>>> td {
  border-right: 1px solid grey !important;
}*/
.bottomTable>>>.v-data-table__wrapper {
  direction: ltr;
}

.bottom-list-change-address-space {
  width: 92%;
  min-width: 92%;
  max-width: 92%;
  padding: 0px !important;
}

.bottom-list-change-address-space3 {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  padding: 0px !important;
}

.bottom-list-change-address-space2 {
  width: 8%;
  min-width: 8%;
  max-width: 8%;
  padding: 0px !important;
}

.my-row {
  display: flex !important;
  flex-wrap: wrap !important;
  margin: 0px !important;
  align-items: center;
  padding: 0px !important;
}

>>>.truncate {
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>>.truncate2 {
  display: inline-block;
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>>th {
  position: sticky !important;
  top: 0 !important;
}

.custom-autocomplete-item .item-code {
  font-weight: 600;
  color: #000029;
  margin-left: 8px;
  font-size: 16px;
  unicode-bidi: embed;
  direction: ltr;
}
</style>
<style>
.zone-autocomplete-menu .v-list-item {
  min-height: 35px !important;
}

.zone-autocomplete-menu .v-list-item__action {
  margin: 2px 0px 4px 2px !important;
}
</style>
